import React from 'react';
import { Link } from 'react-router-dom';
import { LinkedinIcon, MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
import { useTranslation } from '../i18n/useTranslation';
const Footer = () => {
  const {
    t
  } = useTranslation();
  return <footer className="bg-gray-900 text-white pt-16 pb-8" data-id="element-1639">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1640">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-1641">
          <div data-id="element-1642">
            <Link to="/" className="flex items-center mb-4" data-id="element-1643">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rhREvAJ4b5296S85upFAnM/logonew.png" alt="Shopilots Logo" className="h-10 w-auto" data-id="element-1644" />
            </Link>
            <p className="text-gray-400 mb-4" data-id="element-1645">{t('footer.description')}</p>
            <div className="flex space-x-4" data-id="element-1646">
              <a href="https://www.linkedin.com/company/shopilots" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-1647">
                <LinkedinIcon className="h-5 w-5" data-id="element-1648" />
              </a>
            </div>
          </div>
          <div data-id="element-1649">
            <h3 className="text-lg font-semibold mb-4" data-id="element-1650">
              {t('footer.solutions')}
            </h3>
            <ul className="space-y-2" data-id="element-1651">
              <li data-id="element-1652">
                <a href="/#solutions" className="text-gray-400 hover:text-white transition-colors" data-id="element-1653">
                  Website AI Agent
                </a>
              </li>
              <li data-id="element-1654">
                <a href="/#solutions" className="text-gray-400 hover:text-white transition-colors" data-id="element-1655">
                  Social Media AI Agent
                </a>
              </li>
              <li data-id="element-1656">
                <a href="/#solutions" className="text-gray-400 hover:text-white transition-colors" data-id="element-1657">
                  Messenger AI Agent
                </a>
              </li>
              <li data-id="element-1658">
                <a href="/#solutions" className="text-gray-400 hover:text-white transition-colors" data-id="element-1659">
                  Call AI Agent
                </a>
              </li>
              <li data-id="element-1660">
                <a href="/gpt-store" className="text-gray-400 hover:text-white transition-colors" data-id="element-1661">
                  GPT Store Solutions
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-1662">
            <h3 className="text-lg font-semibold mb-4" data-id="element-1663">
              {t('footer.resources')}
            </h3>
            <ul className="space-y-2" data-id="element-1664">
              <li data-id="element-1665">
                <Link to="/blog" className="text-gray-400 hover:text-white transition-colors" data-id="element-1666">
                  Blog
                </Link>
              </li>
              <li data-id="element-1667">
                <Link to="/case_studies" className="text-gray-400 hover:text-white transition-colors" data-id="element-1668">
                  Case Studies
                </Link>
              </li>
              <li data-id="element-1669">
                <a href="https://www.cta.tech/articles/the-impact-and-use-cases-of-ai-in-retail/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-1670">
                  AI in Retail
                </a>
              </li>
              <li data-id="element-1671">
                <a href="https://www.rswebsols.com/ai-in-consumer-electronics-evolution-impact/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-1672">
                  AI in Consumer Electronics
                </a>
              </li>
              <li data-id="element-1673">
                <a href="https://www.apu.apus.edu/area-of-study/business-and-management/resources/artificial-intelligence-in-retail-and-improving-efficiency/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-1674">
                  AI Retail Efficiency
                </a>
              </li>
              <li data-id="element-1675">
                <a href="https://www.linkedin.com/posts/bengeva_ai-lagoons-vs-the-chatgpt-ocean-the-website-activity-7355979681709338624-c5ML" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-1676">
                  AI Lagoons for Retail
                </a>
              </li>
              <li data-id="element-1677">
                <a href="https://www.linkedin.com/posts/bengeva_its-not-me-its-you-in-ai-commerce-activity-7366007722976145410-GZeF" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-1678">
                  Shopilots Hidden Layer
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-1679">
            <h3 className="text-lg font-semibold mb-4" data-id="element-1680">
              {t('footer.contactUs')}
            </h3>
            <ul className="space-y-4" data-id="element-1681">
              <li className="flex items-start" data-id="element-1682">
                <MapPinIcon className="h-5 w-5 text-gray-400 mr-2 flex-shrink-0 mt-0.5" data-id="element-1683" />
                <span className="text-gray-400" data-id="element-1684">
                  Level 1/9/13 Bronte Rd, Bondi Junction NSW 2022, Australia
                </span>
              </li>
              <li className="flex items-start" data-id="element-1685">
                <PhoneIcon className="h-5 w-5 text-gray-400 mr-2 flex-shrink-0 mt-0.5" data-id="element-1686" />
                <a href="tel:+19146011670" className="text-gray-400 hover:text-white transition-colors" data-id="element-1687">
                  (914) 601-1670
                </a>
              </li>
              <li className="flex items-start" data-id="element-1688">
                <MailIcon className="h-5 w-5 text-gray-400 mr-2 flex-shrink-0 mt-0.5" data-id="element-1689" />
                <a href="mailto:ben@shopilots.com" className="text-gray-400 hover:text-white transition-colors" data-id="element-1690">
                  ben@shopilots.com
                </a>
              </li>
              <li data-id="element-1691">
                <a href="https://shoppingexpert.ai" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors flex items-center" data-id="element-1692">
                  <span className="mr-2" data-id="element-1693">🛍️</span>
                  {t('nav.shoppingExpert')}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8" data-id="element-1694">
          <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-1695">
            <p className="text-gray-400 text-sm mb-4 md:mb-0" data-id="element-1696">
              &copy; {new Date().getFullYear()} Shopilots.{' '}
              {t('footer.copyright')}
            </p>
            <div className="flex space-x-6" data-id="element-1697">
              <Link to="/privacy-policy" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-1698">
                {t('footer.links.privacyPolicy')}
              </Link>
              <Link to="/terms-of-service" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-1699">
                {t('footer.links.termsOfService')}
              </Link>
              <a href="https://shopilots.com/sitemap.xml" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-1700">
                {t('footer.links.sitemap')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;